import { IShowcaseCourse } from 'interface/showcase';
import { dateFormater } from 'utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Button, Box, Typography } from '@material-ui/core';
import { ReactComponent as PlayIcon } from 'assets/svg/play.svg';
import ThumbUp from '@material-ui/icons/ThumbUp';
import Share from '@material-ui/icons/Share';
import { useState } from 'react';
import courseService from 'services/course';
import { enStatus } from 'interface/course';
import ShareModal from '../ShareModal/Index';
import { FEATURE_LIKE } from 'settings';
interface IProps {
  course: IShowcaseCourse;
  isNewCourse: boolean;
  onClick: () => void;
}

const useStyles = makeStyles((theme) => ({
  whiteButton: {
    background: theme.palette.grey[200],
    '&:hover': {
      background: theme.palette.grey[300],
    },
    '& > span': {
      paddingRight: theme.spacing(1),
      textTransform: 'none',
      fontSize: 14,
      fontWeight: 600,
      color: theme.palette.grey[600],
      '& svg': {
        color: theme.palette.grey[600],
        width: '12px !important',
      },
    },
    '@media(min-width: 770px) and (max-width: 1440px)': {
      '& > svg': {
        width: '10px !important',
      },
      '& > span': {
        fontSize: 10,
      },
    },
  },
  header: {
    display: 'flex',
    flextDirection: 'row',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      width: '100%',
      justifyContent: 'space-between',
    },
  },
  iconButton: {
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
    '& span': {
      marginLeft: 0,
    },
    '& > div:first-child': {
      height: '100%',
    },
    '@media (max-width: 1024px)': {
      width: 24,
      height: 24,
      '& svg': {
        fontSize: 24,
      },
    },
    '@media (min-width: 1025px)': {
      width: 32,
      height: 32,
      '& svg': {
        fontSize: 32,
      },
    },
    '& svg': {
      transition: '0.5s',
      color: theme.palette.grey[200],
      '&:hover': {
        color: theme.palette.grey[300],
      },
    },
    '& *[data-liked=true]': {
      '& svg': {
        fill: theme.palette.primary.main,
      },
    },
    '& *[data-disabled=true]': {
      cursor: 'inherit',
      pointerEvenets: 'none',
    },
  },
  statusTitle: {
    fontSize: 24,
    fontWeight: 700,
    color: theme.palette.common.white,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    '@media(max-width: 1024px)': {
      marginBottom: theme.spacing(1),
    },
  },
  buttons: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: theme.spacing(2),
  },
  icon: {
    width: 32,
    height: 32,
  },
  input: {
    position: 'absolute',
    width: '0px !important',
    height: '0px !important',
    padding: '0px !important',
    opacity: 0,
  },
  status: {
    background: theme.palette.success.light,
    borderRadius: 2,
    maxHeight: 20,
    fontSize: '10px !important',
    whiteSpace: 'nowrap',
    padding: theme.spacing(1, 2),
    '@media(max-width: 1669px)': {
      marginTop: theme.spacing(2),
    },
    '@media(max-width: 1440px)': {
      paddingTop: theme.spacing(1),
    },
  },
}));

const ContentDefault = (props: IProps) => {
  const [liked, setLiked] = useState(Boolean(props.course.like));
  const [loading, setLoading] = useState(false);
  const [openShare, setOpenShare] = useState(false);
  const classes = useStyles();

  const toggleLike = () => {
    setLoading(true);
    setLiked((isTrue) => !isTrue);
    courseService.like(props.course.hash).then(() => {
      setLoading(false);
    });
  };

  const openModalShare = () => {
    setOpenShare(true);
  };

  const { expire_at, status } = props.course;

  return (
    <div className={classes.container}>
      <Box
        width='100%'
        display='flex'
        flexDirection='row'
        alignItems='center'
        justifyContent='space-between'
        flexWrap='wrap'
      >
        <div className={classes.header}>
          <Button
            onClick={props.onClick}
            startIcon={<PlayIcon width={14} height={14} />}
            variant='contained'
            className={classes.whiteButton}
            id='card-course-acess'
          >
            Acessar
          </Button>
          <Box marginLeft={3} marginRight={3} className={classes.buttons}>
            {FEATURE_LIKE && (
              <div className={classes.iconButton}>
                <div data-disabled={loading} data-liked={liked} onClick={toggleLike}>
                  <ThumbUp />
                </div>
              </div>
            )}
            <div className={classes.iconButton}>
              <div onClick={openModalShare} id='btn-share-course'>
                <Share />
              </div>
            </div>
          </Box>
        </div>
        {!props.isNewCourse && Boolean(expire_at) && status !== enStatus.EXPIRED && (
          <Typography variant='body2' className={classes.status}>
            Válido até {dateFormater(String(props.course.expire_at))}
          </Typography>
        )}
      </Box>
      {props.isNewCourse && <Typography className={classes.statusTitle}>Novo conteúdo</Typography>}
      <ShareModal isOpen={openShare} setIsOpen={setOpenShare} shareLink={props.course.share}/>
    </div>
  );
};

export default ContentDefault;
